import React from 'react';

const PANEL_ORDER = [
  { key: 'image', title: 'Artwork Chooser' },
  { key: 'tv', title: 'TV Content' },
  { key: 'social', title: 'Social Posts' },
  { key: 'announcement', title: 'Announcements' },
  { key: 'overlay', title: 'Overlay Ads' },
  { key: 'landing', title: 'Landing Page' },
  { key: 'advertising', title: 'Advertising' },
];

function StatusBox({ state }) {
  if (state === 'complete') {
    return (
      <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-emerald-500/50 bg-emerald-500/15 text-xl text-emerald-200">
        ✓
      </div>
    );
  }
  if (state === 'error') {
    return (
      <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-red-500/50 bg-red-500/15 text-xl text-red-200">
        !
      </div>
    );
  }
  if (state === 'in_progress') {
    return (
      <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-indigo-500/50 bg-indigo-500/15 text-xs font-semibold uppercase tracking-wide text-indigo-100">
        ...
      </div>
    );
  }
  return (
    <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-700 bg-gray-800 text-xl text-gray-500">
      □
    </div>
  );
}

export default function CampaignGenerationProgress({ progress, title = 'Generation Progress' }) {
  if (!progress?.panels) return null;

  return (
    <div className="rounded-xl border border-gray-800 bg-gray-950/80 p-4">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <p className="text-sm text-gray-400">
            {progress.isLocked
              ? 'Panels will unlock after the artwork finishes generating.'
              : 'Generated sections are ready to review.'}
          </p>
        </div>
        <div className="text-xs uppercase tracking-wide text-gray-500">
          {progress.isLocked ? 'Generating assets' : 'Ready to edit'}
        </div>
      </div>

      <div className="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {PANEL_ORDER.map((panel) => {
          const panelStatus = progress.panels?.[panel.key] || {};
          const state = panelStatus.state || 'pending';
          return (
            <div
              key={panel.key}
              className={`rounded-xl border p-4 ${
                state === 'complete'
                  ? 'border-emerald-500/30 bg-emerald-950/10'
                  : state === 'in_progress'
                    ? 'border-indigo-500/30 bg-indigo-950/20'
                    : state === 'error'
                      ? 'border-red-500/30 bg-red-950/10'
                      : 'border-gray-800 bg-gray-900/80'
              }`}
            >
              <div className="flex items-start gap-3">
                <StatusBox state={state} />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold text-white">{panel.title}</div>
                  <div className="mt-2 text-sm text-gray-300">
                    {panelStatus.label || 'Waiting...'}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
